/**
 * The moment a printed form describes.
 *
 * A completed form prints the patient as they stood when it was locked, so print views that work
 * something out from the date — age, the ASAM adult/adolescent wording, whether a medication is
 * still active — measure against this instead of today. BnFormRender provides the lock time in
 * print view and null otherwise; print widgets read it through `printAsOf()` in printData.js.
 */

/** The injection key under which BnFormRender offers the printed form's lock time. */
export const PRINT_AS_OF = Symbol('printAsOf');
